module.exports = __webpack_public_path__ + "assets/img/35.e5fda2b3.png";